// Presentation only: never alter product handles, cart IDs or Shopify records.
(() => {
  const rebrand = (value) => value
    .replace(/hello@belofay(?:\.co\.uk|\.com|\.uk)\b/gi, 'hello@tiffanylighthouse.co.uk')
    .replace(/\bbelofay\b/gi, 'Tiffany Light House');
  const skip = 'script, style, textarea, input, [contenteditable="true"]';
  function update(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.parentElement && !root.parentElement.closest(skip)) {
        const next = rebrand(root.nodeValue);
        if (next !== root.nodeValue) root.nodeValue = next;
      }
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(skip)) return;
    const nodes = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (nodes.nextNode()) update(nodes.currentNode);
    const elements = [root, ...root.querySelectorAll('[aria-label], [title], [alt], a[href^="mailto:"]')];
    elements.forEach((element) => {
      if (element.closest(skip)) return;
      ['aria-label', 'title', 'alt'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value && rebrand(value) !== value) element.setAttribute(attribute, rebrand(value));
      });
      const href = element.getAttribute('href');
      if (href && /^mailto:hello@belofay(?:\.co\.uk|\.com|\.uk)(?:[?]|$)/i.test(href)) {
        element.setAttribute('href', href.replace(/^mailto:hello@belofay(?:\.co\.uk|\.com|\.uk)/i, 'mailto:hello@tiffanylighthouse.co.uk'));
      }
    });
  }
  update(document.body);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') update(record.target);
      else record.addedNodes.forEach(update);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
